import { DateTruncationTypes } from '../schema/column-records';
export const dateTruncTypeToMomentUnitMap = {
  // MINUTE refers to daily with timestamp
  [DateTruncationTypes.MINUTE]: 'day',
  [DateTruncationTypes.DAY]: 'day',
  [DateTruncationTypes.WEEK]: 'isoWeek',
  [DateTruncationTypes.MONTH]: 'month',
  [DateTruncationTypes.QUARTER]: 'quarter',
  [DateTruncationTypes.YEAR]: 'year'
};